import appointmentImg from "../Assets/images/appointmentManagment.png"
import PosbillingImg from "../Assets/images/posBilling.webp"
import multipleBranchImg from "../Assets/images/multipleBranch.webp"
import manageSalesImg from "../Assets/images/manageSales.avif"
import stockManagmentImg from "../Assets/images/stockManagment.webp"
import staffManagmentImg from "../Assets/images/staffManagment.avif"
import marketingImg from "../Assets/images/marketing.jpg"
import membershipImg from "../Assets/images/membershipPlan.avif"

export const data = [
    {
        id: 1,
        imgUrl: appointmentImg,
        heading: "Appointment management ",
        para: "Manage your customers with our specially designed appointment software for salons. Let your clients choose the staff and book their appointments with mobile apps or websites with ease."
    },
    {
        id: 2,
        imgUrl: PosbillingImg,
        heading: "POS billing Software",
        para: "Make the checkout process smooth and error-free with our POS billing software. Automate billing calculations, manage split payments, apply personalized discounts, and many more."
    },
    {
        id: 3,
        imgUrl:multipleBranchImg,
        heading: "Handle multiple branch with ease",
        para: "With the best salon software services in India, handle multiple salon branches efficiently. Our centralized salon management software enables clients to monitor and manage different branches in different locations with a single system. "
    },
    {
        id: 4,
        imgUrl: manageSalesImg,
        heading: "Manage and boost sales ",
        para: "Sales is the core of business especially when it comes to beauty spas and hair salons. With Your Salon’s CRM solutions, manage leads, automate marketing campaigns and recommendations, take follow-ups, and maximize revenues. "
    },
    {
        id: 5,
        imgUrl:stockManagmentImg,
        heading: "Stock management",
        para: " Make the complex inventory management process seamless with our comprehensive salon software. Our software features include inventory tracking, order management, automated notifications, product integrations, inventory reporting, and whatnot. "
    },
    {
        id: 6,
        imgUrl: staffManagmentImg,
        heading: "Staff management ",
        para: " Enhance employee productivity and satisfaction with our salon-specific staff management software. Track attendance, leaves, feedback, and reviews of staff. Automate the complex payroll considering working hours, overtime, targets, and tax."
    },
    {
        id: 7,
        imgUrl: marketingImg,
        heading: "Level up your Marketing campaigns ",
        para: "Boost customer visibility and online presence with our robust salon software. Create multiple marketing campaigns, automate emails and personalized messages, schedule ads, and customize promotions at a single click. "

    },
    {
        id: 8,
        imgUrl: membershipImg,
        heading: "Client membership ",
        para:"Your Salon knows the importance of Membership programs for salons and spas. Increase repeat customer rate by creating, managing, tracking, and upgrading client membership. Customize Membership plans with personalized offers and discounts. "
    },
]